import React from 'react';
import type { LucideIcon } from 'lucide-react';

type BadgeVariant = 'default' | 'success' | 'warning' | 'danger' | 'info' | 'gold' | 'muted';

const variantClasses: Record<BadgeVariant, string> = {
  default: 'bg-pt-forest/5 text-pt-forest/60 border-pt-forest/10',
  success: 'bg-emerald-50 text-emerald-600 border-emerald-100',
  warning: 'bg-pt-gold/10 text-pt-gold-text border-pt-gold/20',
  danger: 'bg-pt-ruby/10 text-pt-ruby border-pt-ruby/20',
  info: 'bg-pt-forest/8 text-pt-forest border-pt-forest/15',
  gold: 'bg-pt-gold/10 text-pt-gold-text border-pt-gold/20',
  muted: 'bg-pt-cream text-pt-sage-text border-pt-forest/5',
};

export interface BadgeProps {
  variant?: BadgeVariant;
  label: string;
  icon?: LucideIcon;
  size?: 'sm' | 'md';
  className?: string;
  onClick?: () => void;
}

const Badge: React.FC<BadgeProps> = ({
  variant = 'default',
  label,
  icon: Icon,
  size = 'md',
  className = '',
  onClick,
}) => {
  const isSmall = size === 'sm';
  const Tag = onClick ? 'button' : 'span';

  return (
    <Tag
      type={onClick ? 'button' : undefined}
      onClick={onClick}
      className={`inline-flex items-center gap-1.5 border font-black uppercase tracking-widest transition-all ${
        isSmall ? 'px-2 py-0.5 rounded-full text-[8px]' : 'px-3 py-1.5 rounded-xl text-[9px]'
      } ${onClick ? 'cursor-pointer hover:shadow-md' : ''} ${variantClasses[variant]} ${className}`}
    >
      {Icon && <Icon size={isSmall ? 8 : 14} />}
      {label}
    </Tag>
  );
};

export default React.memo(Badge);
